import isShareDisabled from './isShareDisabled';
import store from '../store/Store';
import { PublishStatus } from '../store/schema/BookWithMeOrganizerStore';
import getMeetingTypes from './getMeetingTypes';
import getPbpSettingRequestStatus from './getPbpSettingRequestStatus';
import type ServicesRequestStatus from '../store/schema/ServicesRequestStatus';
import getMailboxHash from './getMailboxHash';
import { isFeatureEnabled } from 'owa-feature-flags';

/**
 * Selector function see whether we should show the progress bar
 * We show the progress bar IF :
 * the page is fully loaded, AND
 * the page is not published on the attendee side OR
 * the attendee page has been published and this is the first time the organizer is seeing their page fully "ready" OR
 * the organizer only has the default meeting type, aka has not created a meeting type
 */
export default function showProgressBar(): boolean {
    //We don't need this progress bar, post modernaization
    if (isFeatureEnabled('bookwithme-c1B2Migration')) {
        return false;
    }
    let shouldShowProgressBar = false;

    const storeMeetingTypes = getMeetingTypes();
    // helps keep track if we should show the bookings page as ready to the user or not.
    // If the mailbox hash is not retrieved, the booking page is not yet ready.
    const bookingDataLoaded =
        getMailboxHash() === null || getMailboxHash === undefined ? false : true;

    if (
        getPbpSettingRequestStatus() == 2 &&
        bookingDataLoaded &&
        store.BookingPagePublishedStatus != PublishStatus.Published &&
        (isShareDisabled() ||
            store.BookingPagePublishedStatus == PublishStatus.Complete ||
            storeMeetingTypes.size < 1)
    ) {
        shouldShowProgressBar = true;
    }

    return shouldShowProgressBar;
}
